import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonLink from '@hiredigital/ui/Button/NextButtonLink';
import Button from '@hiredigital/ui/Button';
import Styles from './InteractiveButton.module.scss';

const InteractiveButton = ({ className, to, href, children, ...props }) => {
  let Component;
  if (to || href) {
    Component = ButtonLink;
  } else {
    Component = Button;
  }
  return (
    <Component
      className={classNames(Styles.button, className)}
      href={to || href || undefined}
      {...props}>
      {children}
    </Component>
  );
};

InteractiveButton.Type = {
  WHITE: ButtonLink.Type.WHITE,
  BLUE: ButtonLink.Type.BLUE,
  DARKBLUE: ButtonLink.Type.DARKBLUE,
  WHITE_BLUE_OUTLINE: ButtonLink.Type.WHITE_BLUE_OUTLINE,
  WHITE_OUTLINE: ButtonLink.Type.WHITE_OUTLINE,
  BLUE_OUTLINE: ButtonLink.Type.BLUE_OUTLINE,
};

InteractiveButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
};

export default InteractiveButton;
